<template>
    <!-- 尽调报告 -->
    <el-tabs v-model="activeColumn" type="border-card" class="tabs-card-one">
        <el-tab-pane name="one" label="产品策略">
            <productStrategy></productStrategy>
        </el-tab-pane>
        <el-tab-pane name="two" label="运营风控">
            <operationalRiskControl></operationalRiskControl>
        </el-tab-pane>
        <el-tab-pane name="three" label="报告列表">
            <reportList></reportList>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
import productStrategy from "./productStrategy.vue"
import operationalRiskControl from "./operationalRiskControl.vue"
import reportList from "./reportList.vue"
export default {
    name: "dueDiligenceReport",
    components: {
        productStrategy,
        operationalRiskControl,
        reportList,
    },
    data() {
        return {
            activeColumn: 'one',
        }
    }
}
</script>

<style lang="less" scoped>
</style>